import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components/macro';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import { lessonsSizes } from '@mirinae/lessons/modules/defines/styles';
import { getElementComponent } from '@mirinae/lessons/components/lesson/elementComponentMap';
import { layoutCurrentStep } from '@mirinae/lessons/modules/libs/layoutLib';

const ElementFlexBox = styled.div`
    display: flex;
    flex-direction: column;
    width: ${lessonsSizes.lessonBounds.width}px;
`;

const ElementRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: ${props => props.row.margin.top}px;
    margin-left: ${props => props.row.margin.left}px;
    margin-right: ${props => props.row.margin.right}px;
`;


// standard page-element renderer - map over page elements for current page-build step calling their table-driven rendering components
const PageElements = ({ page, except, mapComponent, layoutFilter, displayFilter, paddingBottom, mounted }) => {
    const [rows, setRows] = useState([]);
    const player = useContext(PlayerContext);

    useEffect(() => {
        const rows = layoutCurrentStep(page, player.currentStep, except, displayFilter, layoutFilter, paddingBottom);
        setRows(rows);
    }, []);

    useEffect(() => {
        if (mounted) mounted(true);
    }, [rows]);

    return (
        <ElementFlexBox>
            { rows.map((row, i) => (
                <ElementRow key={i} row={row}>
                    { row.elements.filter(e => !displayFilter || displayFilter(e)).map(e => {
                        const ElementComponent = (mapComponent && mapComponent(e)) || getElementComponent(e);
                        return ElementComponent && <ElementComponent key={e.title + e.index} element={e} />;
                    })}
                </ElementRow>
            ))}
        </ElementFlexBox>
    );
};

export default PageElements;


//     return page.children.map(step => (
//         step.index <= player.step && player.inActiveMode(step.modes) && step.children
//             .filter(e => player.inActiveMode(e.modes) && !e.containingFigmaFrameID && !e.managedByPage && e.componentName !== 'miniLessonTableCard')
//             .filter(e => !(except && except.includes(e.componentName)))
//             .map(e => {
//                 const ElementComponent = getElementComponent(e);
//                 return ElementComponent && <ElementComponent key={e.title + e.index} element={e} />;
//             })
//     ));